"use client";

import { useReadContract } from "wagmi";
import { WrapperABI } from "@/contract/abi/wrapper";
import ContractAddress from "@/contract/addresses";
import { useEffectiveAddress } from "@/hooks/auth/useEffectiveAddress";

export const useFetchWrappedTokens = () => {
  const address = useEffectiveAddress();

  return useReadContract({
    address: ContractAddress.WRAPPER,
    abi: WrapperABI,
    functionName: "getUserTokens",
    args: [address as `0x${string}`],
    query: {
      enabled: !!address,
    },
  });
};
